import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: { main: '#1B3A5C', light: '#2E75B6', dark: '#0D1F33' },
    secondary: { main: '#3498DB', light: '#5DADE2', dark: '#2471A3' },
    success: { main: '#27AE60' },
    warning: { main: '#E67E22' },
    error: { main: '#C0392B' },
    background: { default: '#F0F4F8', paper: '#FFFFFF' },
  },
  typography: {
    fontFamily: '"Inter", "Noto Sans", "Arial", sans-serif',
    h1: { fontSize: '2rem', fontWeight: 700, color: '#1B3A5C' },
    h2: { fontSize: '1.5rem', fontWeight: 600, color: '#2E75B6' },
    h3: { fontSize: '1.25rem', fontWeight: 600 },
  },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none', borderRadius: 8, fontWeight: 600 } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' } } },
    MuiPaper: { styleOverrides: { root: { borderRadius: 8 } } },
  },
});
